// Централизованный API клиент с автоматическим добавлением JWT токена
import axios from "axios"
import { getJwtToken } from "./authStorage"
import "./httpAuthGuard";

const REACT_APP_SERVER_URL_TEST = process.env.REACT_APP_SERVER_URL_TEST

// Получить заголовки с JWT токеном
export const getAuthHeaders = () => {
  const jwtToken = getJwtToken()

  const headers = {
    "Content-Type": "application/json",
  }

  if (jwtToken) {
    headers["Authorization"] = `Bearer ${jwtToken}`
    // 
  } else {
    // 
  }

  return headers
}

// Универсальная функция для API запросов с автоматическим JWT
export const apiRequest = async (method, url, data = null, customHeaders = {}) => {
  try {
    const headers = {
      ...getAuthHeaders(),
      ...customHeaders,
    }

    const fullUrl = url.startsWith("http") ? url : `${REACT_APP_SERVER_URL_TEST}${url}`

    // 
    // 

    const config = {
      method,
      url: fullUrl,
      headers,
      withCredentials: true, // для поддержки cookies если нужно
    }

    if (data) {
      config.data = data
      // 
    }

    const response = await axios(config)
    // 
    return response
  } catch (error) {
    // console.error(`[v0][apiClient] ERROR:`, error.response?.status, error.response?.data || error.message)
    throw error
  }
}

// Удобные методы для разных типов запросов
export const apiGet = (url, customHeaders = {}) => apiRequest("get", url, null, customHeaders)
export const apiPost = (url, data, customHeaders = {}) => apiRequest("post", url, data, customHeaders)
export const apiPut = (url, data, customHeaders = {}) => apiRequest("put", url, data, customHeaders)
export const apiDelete = (url, customHeaders = {}) => apiRequest("delete", url, null, customHeaders)
